import { User, Users as UsersIcon } from "lucide-react";
import { useViewScopeStore } from "../../store/viewScopeStore";

/**
 * "Ben / Herkes" (Me / Everyone) global toggle. Lives in the TopBar to the
 * LEFT of the inline search. Persists via viewScopeStore.
 */
export default function ScopeToggle() {
  const { scope, setScope } = useViewScopeStore();
  const isMe = scope === "me";
  return (
    <div
      data-testid="scope-toggle"
      className="inline-flex items-center overflow-hidden rounded-full border border-zinc-200 bg-white text-xs"
    >
      <button
        type="button"
        onClick={() => setScope("me")}
        data-testid="scope-toggle-me"
        aria-pressed={isMe}
        className={[
          "flex items-center gap-1 px-2 py-1.5 transition-colors sm:px-3",
          isMe
            ? "bg-zinc-900 text-white"
            : "bg-white text-zinc-600 hover:bg-zinc-50",
        ].join(" ")}
        title="Sadece sana atanmış olanları göster"
      >
        <User className="h-3.5 w-3.5" strokeWidth={2} />
        <span className="hidden sm:inline">Ben</span>
      </button>
      <button
        type="button"
        onClick={() => setScope("everyone")}
        data-testid="scope-toggle-everyone"
        aria-pressed={!isMe}
        className={[
          "flex items-center gap-1 px-2 py-1.5 transition-colors sm:px-3",
          !isMe
            ? "bg-zinc-900 text-white"
            : "bg-white text-zinc-600 hover:bg-zinc-50",
        ].join(" ")}
        title="Ekip genelini göster"
      >
        <UsersIcon className="h-3.5 w-3.5" strokeWidth={2} />
        <span className="hidden sm:inline">Herkes</span>
      </button>
    </div>
  );
}
